

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// APPROVECONTACTUSSECTION
// APPROVECONTACTUSSECTION


const APPROVECONTACTUSSECTION= createAsyncThunk(
  "approveContactUsSection/approveContactUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveContactUsSectionSlice = createSlice({
  name: "approveContactUsSectionSlice",
  initialState: {
    approveContactUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveContactUsSection: (state) => {
        state.approveContactUsSection.loading = false
        state.approveContactUsSection.error = false
        state.approveContactUsSection.data = []
        state.approveContactUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVECONTACTUSSECTION.fulfilled, (state, action) => {
      state.approveContactUsSection = {
        ...state.approveContactUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVECONTACTUSSECTION.pending, (state, action) => {
      state.approveContactUsSection = {
        ...state.approveContactUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVECONTACTUSSECTION.rejected, (state, action) => {
      state.approveContactUsSection = {
        ...state.approveContactUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveContactUsSectionAction = {
    APPROVECONTACTUSSECTION,
};

export { approveContactUsSectionAction };
export default approveContactUsSectionSlice.reducer;
export const {setInitialStateOfapproveContactUsSection} = approveContactUsSectionSlice.actions
